// extracted by mini-css-extract-plugin
var _1 = "TabElements_group__2b80c";
var _2 = "TabElements_items__bf465";
var _3 = "TabElements_root__c8085";
export { _1 as "group", _2 as "items", _3 as "root" }
